import React from 'react';
import BadgeStyle from './styles';

const Badge = ({ children, ...rest }) => (
  <BadgeStyle>
    {children}
    {rest.dot && <sup className="ant-badge-dot" />}
  </BadgeStyle>
);

export default Badge;
